(() => {
    if (window.LuggexReasonsMedia) { window.LuggexReasonsMedia.scan(document); return; }
    const instances = new WeakMap();
    const initializeMediaPlayback = (section) => {
      if (instances.has(section)) return;

      const slider = section.querySelector('slider-element');
      const cards = Array.from(section.querySelectorAll('[data-luggex-reasons-card]')).filter((card) => card.querySelector('video') || card.dataset.videoSrc || card.dataset.gifSrc);
      if (!cards.length) return;

      const cleanups = [];
      let destroyed = false;
      const listen = (target, type, handler, options) => {
        target.addEventListener(type, handler, options);
        cleanups.push(() => target.removeEventListener(type, handler, options));
      };
      let scrollTimeout;
      const observers = [];

      const desktopQuery = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const imageStates = new WeakMap();

      const getImageState = (card) => {
        const image = card.querySelector('.luggex-reasons__image');
        if (!image) return null;

        let state = imageStates.get(image);
        if (!state) {
          const initialSrc = image.getAttribute('src') || '';
          const staticSrc = card.dataset.staticSrc || (initialSrc !== card.dataset.gifSrc ? initialSrc : '');
          state = {
            image,
            staticSrc,
            staticSrcset: image.getAttribute('srcset') || '',
            staticSizes: image.getAttribute('sizes') || '',
            isPlaying: false,
          };
          imageStates.set(image, state);
        }

        return state;
      };

      const setPlaying = (card, shouldPlay) => {
        if (destroyed && shouldPlay) return;
        const video = card.querySelector('video');
        const gifSrc = card.dataset.gifSrc;
        const play = shouldPlay && !reducedMotionQuery.matches;

        if (video) {
          video.muted = true;
          video.loop = true;
          if (play) {
            const promise = video.play();
            if (promise && typeof promise.then === 'function') {
              promise
                .then(() => { if (!destroyed) card.classList.add('luggex-reasons__card--gif-playing'); })
                .catch(() => card.classList.remove('luggex-reasons__card--gif-playing'));
            } else {
              card.classList.add('luggex-reasons__card--gif-playing');
            }
          } else {
            video.pause();
            try { video.currentTime = 0; } catch (error) {}
            card.classList.remove('luggex-reasons__card--gif-playing');
          }
          return;
        }

        const state = getImageState(card);
        if (!gifSrc || !state) return;
        const canStop = Boolean(state.staticSrc);
        if (state.isPlaying === play) return;

        if (play) {
          state.image.removeAttribute('srcset');
          state.image.removeAttribute('sizes');
          state.image.setAttribute('src', gifSrc);
        } else if (canStop) {
          state.image.setAttribute('src', state.staticSrc);
          if (state.staticSrcset) state.image.setAttribute('srcset', state.staticSrcset);
          if (state.staticSizes) state.image.setAttribute('sizes', state.staticSizes);
        }

        state.isPlaying = play;
        card.classList.toggle('luggex-reasons__card--gif-playing', play);
      };

      const stopAll = () => cards.forEach((card) => setPlaying(card, false));

      const setActiveMobileCard = (activeCard) => {
        if (desktopQuery.matches) return;
        cards.forEach((card) => setPlaying(card, card === activeCard));
      };

      const getMostVisibleMobileCard = () => {
        if (!slider || desktopQuery.matches) return null;

        const sliderBounds = slider.getBoundingClientRect();
        if (sliderBounds.bottom <= 0 || sliderBounds.top >= window.innerHeight) return null;

        const mostVisible = cards
          .map((card) => {
            const bounds = card.getBoundingClientRect();
            const visibleWidth = Math.max(0, Math.min(bounds.right, sliderBounds.right) - Math.max(bounds.left, sliderBounds.left));
            return { card, visibility: visibleWidth / Math.max(bounds.width, 1) };
          })
          .sort((a, b) => b.visibility - a.visibility)[0];

        return mostVisible && mostVisible.visibility >= 0.5 ? mostVisible.card : null;
      };

      const syncMobileCard = () => {
        if (desktopQuery.matches) return;
        const visibleCard = getMostVisibleMobileCard();
        if (visibleCard) {
          setActiveMobileCard(visibleCard);
        } else {
          stopAll();
        }
      };

      cards.forEach((card) => {
        getImageState(card);

        listen(card, 'mouseenter', () => {
          if (desktopQuery.matches) setPlaying(card, true);
        });
        listen(card, 'mouseleave', () => {
          if (desktopQuery.matches) setPlaying(card, false);
        });
        listen(card, 'focusin', () => {
          if (desktopQuery.matches) setPlaying(card, true);
        });
        listen(card, 'focusout', (event) => {
          if (desktopQuery.matches && !card.contains(event.relatedTarget)) setPlaying(card, false);
        });
      });

      if (slider) {

        listen(slider, 'scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(syncMobileCard, 90);
        });

        listen(slider, 'slider:change', (event) => {
          if (!desktopQuery.matches && event.detail && event.detail.currentElement) {
            setActiveMobileCard(event.detail.currentElement);
          }
        });
      }

      if ('IntersectionObserver' in window && slider) {
        const observer = new IntersectionObserver((entries) => {
          if (desktopQuery.matches) return;

          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visibleEntry) setActiveMobileCard(visibleEntry.target);
        }, {
          root: slider,
          threshold: [0.6, 0.8, 1],
        });

        observers.push(observer);
        cards.forEach((card) => observer.observe(card));

        const sectionObserver = new IntersectionObserver((entries) => {
          if (desktopQuery.matches) return;
          if (entries[0]?.isIntersecting) {
            syncMobileCard();
          } else {
            stopAll();
          }
        }, { threshold: 0.15 });

        observers.push(sectionObserver);
        sectionObserver.observe(slider);
      }

      const handleModeChange = () => {
        stopAll();
        if (!desktopQuery.matches) {
          syncMobileCard();
        }
      };

      if (desktopQuery.addEventListener) {
        listen(desktopQuery, 'change', handleModeChange);
        listen(reducedMotionQuery, 'change', handleModeChange);
      } else {
        desktopQuery.addListener(handleModeChange);
        reducedMotionQuery.addListener(handleModeChange);
        cleanups.push(() => desktopQuery.removeListener(handleModeChange), () => reducedMotionQuery.removeListener(handleModeChange));
      }

      const alternateCards = cards.filter((card) => card.dataset.alternateVideoSrc);
      if (alternateCards.length && window.theme?.pubsub) {
        const unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data?.productId) !== section.dataset.productId) return;
          const options = (event.data?.variant?.options || []).map((option) => String(option).trim().toLowerCase());
          alternateCards.forEach((card) => {
            const alternate = options.includes(card.dataset.alternateColor.trim().toLowerCase());
            const nextSource = alternate ? card.dataset.alternateVideoSrc : card.dataset.primaryVideoSrc;
            const video = card.querySelector('video');
            if (!video || !nextSource || card.dataset.videoSrc === nextSource) return;
            video.pause();
            card.classList.remove('luggex-reasons__card--gif-playing');
            card.dataset.videoSrc = nextSource;
            video.src = nextSource;
            video.poster = alternate ? card.dataset.alternatePoster : card.dataset.primaryPoster;
            video.load();
            if (desktopQuery.matches && card.matches(':hover')) setPlaying(card, true);
          });
          syncMobileCard();
        });
        cleanups.push(unsubscribe);
      }
      instances.set(section, () => {
        destroyed = true;
        clearTimeout(scrollTimeout);
        cleanups.forEach((cleanup) => cleanup());
        observers.forEach((observer) => observer.disconnect());
        stopAll();
        instances.delete(section);
      });
      syncMobileCard();
    };
    const rootsWithin = (scope) => [
      ...(scope.matches?.('.luggex-reasons') ? [scope] : []),
      ...scope.querySelectorAll('.luggex-reasons'),
    ];
    const scan = (scope) => rootsWithin(scope).forEach(initializeMediaPlayback);
    window.LuggexReasonsMedia = { scan };
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      rootsWithin(event.target).forEach((root) => instances.get(root)?.());
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }
  })();
